import { defineMessage } from '@lingui/core/macro';
import { i18n } from '@lingui/core';

const SPELL_CATEGORY = {
  ROTATIONAL: 'ROTATIONAL',
  ROTATIONAL_AOE: 'ROTATIONAL_AOE',
  ITEMS: 'ITEMS',
  COOLDOWNS: 'COOLDOWNS',
  DEFENSIVE: 'DEFENSIVE',
  SEMI_DEFENSIVE: 'SEMI_DEFENSIVE',
  OTHERS: 'OTHERS',
  UTILITY: 'UTILITY',
  HEALER_DAMAGING_SPELL: 'HEALER_DAMAGING_SPELL',
  CONSUMABLE: 'CONSUMABLE',
  HIDDEN: 'HIDDEN',
} as const;

export function getSpellCategoryName(category: keyof typeof SPELL_CATEGORY) {
  switch (category) {
    case SPELL_CATEGORY.ROTATIONAL:
      return i18n._(
        defineMessage({
          id: 'core.abilities.spellCategories.rotational',
          message: `循环法术`,
        }),
      );
    case SPELL_CATEGORY.ROTATIONAL_AOE:
      return i18n._(
        defineMessage({
          id: 'core.abilities.spellCategories.rotationalAoe',
          message: `AOE 法术`,
        }),
      );
    case SPELL_CATEGORY.ITEMS:
      return i18n._(
        defineMessage({
          id: 'core.abilities.spellCategories.items',
          message: `物品`,
        }),
      );
    case SPELL_CATEGORY.COOLDOWNS:
      return i18n._(
        defineMessage({
          id: 'core.abilities.spellCategories.cooldowns',
          message: `冷却`,
        }),
      );
    case SPELL_CATEGORY.DEFENSIVE:
      return i18n._(
        defineMessage({
          id: 'core.abilities.spellCategories.defensive',
          message: `防御冷却`,
        }),
      );
    case SPELL_CATEGORY.SEMI_DEFENSIVE:
      return i18n._(
        defineMessage({
          id: 'core.abilities.spellCategories.semiDefensive',
          message: `攻防冷却`,
        }),
      );
    case SPELL_CATEGORY.OTHERS:
      return i18n._(
        defineMessage({
          id: 'core.abilities.spellCategories.others',
          message: `技能`,
        }),
      );
    case SPELL_CATEGORY.UTILITY:
      return i18n._(
        defineMessage({
          id: 'core.abilities.spellCategories.utility',
          message: `功能性`,
        }),
      );
    case SPELL_CATEGORY.HEALER_DAMAGING_SPELL:
      return i18n._(
        defineMessage({
          id: 'core.abilities.spellCategories.healerDamagingSpell',
          message: `伤害法术`,
        }),
      );
    case SPELL_CATEGORY.CONSUMABLE:
      return i18n._(
        defineMessage({
          id: 'core.abilities.spellCategories.consumable',
          message: `消耗品`,
        }),
      );
    default:
      // Should never happen
      return '未知技能分类';
  }
}

export default SPELL_CATEGORY;
